import { FLOW_TYPE } from 'consts/flows';

export function FinishPageTranslationKeys(entityType = '', flowType = '', portfolioId = '') {
	const suffix = portfolioId ? '_with_portfolio' : '';

	const primary = {
		flowType,
		isPrimary: true,
		btn: 'hero_btn_title',
		description: `${flowType}_hero_text${suffix}`,
		header: 'mv_header_title',
		leftText: `trading_in_cash_text_${entityType}`,
		leftTitle: `trading_in_cash_title_${entityType}`,
		rightText: `evaluate_your_knowledge_text_${entityType}`,
		rightTitle: `evaluate_your_knowledge_title_${entityType}`,
		title: `${flowType}_hero_title${suffix}`
	};

	switch (flowType) {
		case FLOW_TYPE.AV:
			return {
				...primary,
				isPrimary: null,
				btn: 'av_hero_btn_title'
			};
		case FLOW_TYPE.EB:
		case FLOW_TYPE.ER:
		case FLOW_TYPE.RR_EB:
		case FLOW_TYPE.RR_ER:
		case FLOW_TYPE.RR_SU:
			return {
				...primary,
				isPrimary: false,
				leftText: 'er_text_left',
				leftTitle: 'er_heading_left',
				rightText: 'er_text_right',
				rightTitle: 'er_heading_right'
			};
		default:
			return primary;
	}
}
